import { graphql, useStaticQuery } from "gatsby"
import React, { FC, useMemo } from "react"

import {
  BespokeComponentFragmentFragment,
  DelightLabsPrefooterQueryQuery,
} from "@graphqlTypes"

import HubspotForm from "@components/HubspotForm/HubspotForm"

import "./DelightLabsPrefooter.scss"
import ImageAboveFold from "@components/ImageAboveFold/ImageAboveFold"

type DelightLabsPrefooterJsonPayload = {
  bodyText: string,
  finePrint: string,
  title: string,
}

const DelightLabsPrefooter: FC<{
  contentful_id: BespokeComponentFragmentFragment["contentful_id"],
  jsonPayload: BespokeComponentFragmentFragment["jsonPayload"],
}> = ({
  contentful_id,
  jsonPayload,
}) => {
    const {
      backgroundImageData,
      backgroundImageGlobeData,
      delightLabsPrefooterHubspotForm,
    } = useStaticQuery<DelightLabsPrefooterQueryQuery>(graphql`
      query DelightLabsPrefooterQuery {
        delightLabsPrefooterHubspotForm: hubspotForm(alternative_id:{eq:"4ae45770-19c8-446b-bf39-72b7aecb720b"}) {
          ...HubspotFormFragment
        }
        backgroundImageData: contentfulAsset(contentful_id:{eq:"6zThUHwq6CGSyYrzl8HMNc"}) {
          imgixImage {
            gatsbyImageData(width: 2000)
          }
        }
        backgroundImageGlobeData: contentfulAsset(contentful_id:{eq:"6kfnqV6lrZuEQ4kRIwQLFG"}) {
          imgixImage {
            gatsbyImageData(width: 2000)
          }
        }
      }
    `)

    const json = useMemo(() => {
      try {
        return JSON.parse(jsonPayload?.internal.content || "") as DelightLabsPrefooterJsonPayload
      } catch (e) {
        console.error(`Failed to parse JSON Payload: DelightLabsPrefooter (${contentful_id})`)
        return null
      }
    }, [jsonPayload])

    if (!json) return null

    return (
      <div className="DelightLabsPrefooter">
        <div className="background-image-comp">
          {backgroundImageData?.imgixImage?.gatsbyImageData && (
            <ImageAboveFold
              alt=""
              aspectRatio={16 / 10}
              className="background-image"
              imageData={backgroundImageData.imgixImage.gatsbyImageData}
              role="presentation"
            />
          )}
          {backgroundImageGlobeData?.imgixImage?.gatsbyImageData && (
            <ImageAboveFold
              alt=""
              aspectRatio={16 / 10}
              className="background-image-globe"
              imageData={backgroundImageGlobeData.imgixImage.gatsbyImageData}
              role="presentation"
            />
          )}
        </div>
        <div className="container">
          <div className="grid">
            <div className="column">
              <h2
                className="font--victor-narrow"
                dangerouslySetInnerHTML={{ __html: json.title }}
              />
              <p dangerouslySetInnerHTML={{ __html: json.bodyText }} />

              <HubspotForm
                {...delightLabsPrefooterHubspotForm}
              />
            </div>
          </div>
          <div className="column">
            <p
              className="fine-print"
              dangerouslySetInnerHTML={{ __html: json.finePrint }}
            />
          </div>
        </div>
      </div>
    )
  }

export default DelightLabsPrefooter
